module.exports = __webpack_public_path__ + "media/images/illustration_8-358f1a59940a157620d40ae5b873cd49.png";